import React from "react"
import styled from "styled-components"
import { navigate } from "gatsby"
import { ArrowRight, inBrowser } from "@omnichannel/ace-b2b-elements"
import { useState } from "react"

const CookiePolicyPrompt = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  background-color: #333;
  opacity: 0.9;
  padding: 1.6rem 0 1.2rem;
`

const CookieContent = styled.div`
  max-width: 120rem;
  display: flex;
  flex-direction: row;
  margin: auto;
  padding: 0 2rem;
  font-size: 1.4rem;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
  }
`

const CookieText = styled.div`
  width: 65%;
  color: #fff;
  line-height: 150%;
  @media (max-width: 767px) {
    width: 100%;
    line-height: 120%;
  }
`

const CookieAcceptButton = styled.div`
  color: #fff;
  background-color: ${props => props.theme.default.primary};
  height: 100%;
  padding: 1rem 2rem;
  cursor: pointer;
  @media (max-width: 767px) {
    margin-top: 2rem;
  }
`

const LearnMore = styled.span`
  color: ${props => props.theme.default.primary};
  font-weight: 600;
  cursor: pointer;
`

const CookiePolicy = _ => {
  const [hideCookiePolicyPrompt, setHideCookiePolicyPrompt] = useState(
    inBrowser &&
    localStorage.getItem("ACEHARDWARE_COOKIE_NOTICE_GOT_IT") === "ACCEPTED"
  )

  const acceptCookiePolicy = _ => {
    localStorage.setItem("ACEHARDWARE_COOKIE_NOTICE_GOT_IT", "ACCEPTED")
    setHideCookiePolicyPrompt(true)
  }

  return !hideCookiePolicyPrompt ? (
    <CookiePolicyPrompt>
      <CookieContent>
        <CookieText>
          We use cookies and other tracking technologies to improve your
          browsing experience, optimize web performance, and to show you
          personalized content & relevant ads. By browsing our website, you
          consent to our use of cookies and other tracking technologies.{" "}
          <LearnMore onClick={() => navigate("/static/privacy")}>
            Learn More <ArrowRight color={"#0F0ADC"} height={"1"} width={"1"} />
          </LearnMore>
        </CookieText>
        <CookieAcceptButton onClick={() => acceptCookiePolicy()}>
          I Agree
        </CookieAcceptButton>
      </CookieContent>
    </CookiePolicyPrompt>
  ) : null
}

export default CookiePolicy
